import {createFileRoute, redirect} from "@tanstack/react-router";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/_defaultScaffold/marketplace-intelligence/",
)({
    loader: ({params}) => {
        throw redirect({
            params: {workspaceId: params.workspaceId},
            replace: true,
            to: "/w/$workspaceId/marketplace-intelligence/pricing-grid",
        });
    },
});
